<template>
  <div class="cube-input x-input-number">
    <input
      v-if="renderSence === 'edit'"
      class="cube-input-field"
      v-model="inputValue"
      v-bind="$attrs"
      type="number"
      @focus="handleFocus"
      @blur="handleBlur"
    >
    <span v-else-if="renderSence === 'read'" class="cube-input-field text-overflow">{{ inputValue }}</span>
  </div>
</template>

<script>
import MoneyUtil from '@/lib/ui/utils/money.util.js'

export default {
  name: 'XNumberInput',
  props: {
    value: {
      type: [String, Number],
      requried: true
    },
    renderSence: {
      type: String,
      default: 'edit',
      validator(value) {
        return ['edit', 'read'].indexOf(value) !== -1
      }
    },
    decimalNum: {
      type: Number,
    }
  },
  data() {
    return {
      displayValue: '',
      ready: false
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal && !this.ready) {
          this.displayValue = this.formatValue(newVal)
          this.$emit('change', this.displayValue)
        }
      },
      immediate: true
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.displayValue || this.value
      },
      set(value) {
        if (value.length > 15) {
          value = value.slice(0, 15)
        }
        let number = this.formatNumber(value)
        this.$emit('input', number)
        console.log(number)
        this.ready = true
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    }
  },
  methods: {
    formatNumber(value) {
      const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/ // 数字正则
      if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
        return value === '' ? null : value
      } else {
        return this.value
      }
    },
    formatValue(value) {
      return this.decimalNum ? value.toFixed(this.decimalNum) : value
    },
    handleFocus(event) {
      this.displayValue = ''
    },
    handleBlur(event) {
      this.displayValue = this.formatValue(this.inputValue)
      this.$emit('change', this.displayValue)
    }
  }
}
</script>

<style lang="scss">
.x-input-number {
  outline: none;
}
</style>